/*! Thom Form - v1 - 2017-12-01
 * Copyright (c) 2017 THOM */

// jQuery.validator.unobtrusive.adapters.add('shouldbetrue', new Array(), function (
//   options
// ) {
//   options.rules['shouldbetrue'] = true
//   if (options.message) options.messages['shouldbetrue'] = options.message
// })

// jQuery.validator.addMethod('shouldbetrue', function (value, element) {
//   return jQuery(element).is(':checked')
// })
// Add client validator functionality for Checkboxes
require('jquery-form');
require('jquery-validation');
require('jquery-validation-unobtrusive');
// require('./thom_formSteps')


jQuery.validator.addMethod(
  'shouldbetruemethod',
  function (value, element) {
    return $(element).is(':checked')
  },
  ''
);

jQuery.validator.methods["date"] = function (value, element) { return true; } 

jQuery.validator.unobtrusive.adapters.addBool(
  'shouldbetrue',
  'shouldbetruemethod',
  'date'
);


(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define(['jquery'], function (a0) {
      return factory(a0)
    })
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require('jquery'))
  } else {
    factory(root['jQuery'])
  }
})(this, function ($) {
  // THOM MAP
  (function () {
    'use strict'

    /* set default variables */
    var defaults = {
      errorMsg: null,
      errorCallback: function () {},
      myCallback: function () {},
      steps: false,
      stepsCallback: function () {}
    }

    /* variable */
    var $inputFile = null;
    var $inputFileLabel = '';
    var inputFileLabelVal = '';

    /* Plugin fn */
    class Plugin {
      constructor(element, options) {
        // Current select element
        this.el = element;
        // Current jquery element
        this.$el = $(element);
        // select settings
        this.s = $.extend({}, defaults, options);

        // select modules
        this.modules = {};

        this.init();

        return this;
      }
      /* INITIALIZE PLUGIN */
      init() {
        var _ = this;
        // Set Listeners
        _.listeners();
      }
      listeners() {
        var _ = this;

        var formClass = _.$el.attr('class');        
        
        if ($('.' + formClass).exists()) {
          jQuery.validator.unobtrusive.parse('.' + formClass);
        }

        // Button click
        _.$el.find('.thom-form__submit').unbind('click');
        _.$el.find('.thom-form__submit').click(function (e) {
          e.preventDefault()
          $(this).prop('disabled', true);

          // Response Form
          _.response();
        });

        // Input + Textarea keyboard button press
        _.$el.find('input').keypress(function (e) {
          // Enter pressed?
          if (e.which == 10 || e.which == 13) {
            _.response();
          }
        });

        if (_.$el.find('input[type=file]').exists()) {
          $inputFile = _.$el.find('input[type=file]');
          $inputFileLabel = $inputFile.next('label');
          inputFileLabelVal = $inputFileLabel.html();

          $inputFile.on('change', function (e) {
            var fileName = '';

            if (this.files && this.files.length > 1) {
              fileName = (
                this.getAttribute('data-multiple-caption') || ''
              ).replace('{count}', this.files.length);
            }
            else if (e.target.value) {
              fileName = e.target.value.split('\\').pop();
            }

            if (fileName) {
              $inputFileLabel.find('span').html(fileName);
            }
            else {
              $inputFileLabel.html(inputFileLabelVal);
            }
          });

          // Firefox bug fix
          $inputFile
            .on('focus', function () {
              $inputFile.addClass('has-focus')
            })
            .on('blur', function () {
              $inputFile.removeClass('has-focus')
            });
        }

        // form datepicker
        if (_.$el.find('[data-toggle="datepicker"]').exists()){
          var mydate =  _.$el.find('[data-toggle="datepicker"]').val().replace('00:00:00', '');
          _.$el.find('[data-toggle="datepicker"]').val(mydate)
          _.$el.find('[data-toggle="datepicker"]').datepicker({
            language: $('html').attr('lang'),
            format: 'dd/mm/yyyy'
          });
        }

        if(_.s.steps){
          if(_.$el.find(".thom-form__error li").length > 0){
            // console.log('2')
            _.$el.find(".thom-form__error").fadeIn(300);
          }

          $('.formSteps-nav-item.is-complete').unbind('click');
          $('.formSteps-nav-item.is-complete').click(function(e){
            e.preventDefault();

            $('.formSteps-nav-item').removeClass('is-selected');
            $(this).addClass('is-selected');

            _.loader('show');
            $.ajax({
              url: $(this).data('url'),
            })
              .done(function( data ) {
                _.replaceForm(data);
              });
            
            return false;
          });
        }
      }
      loader(action) {
        var _ = this;
        if (action === 'show') {
          var elem = document.createElement('div');
          elem.setAttribute('id', 'spinnerform');
          elem.innerHTML =
            '<div class="sk-chase">' +
              '<div class="sk-chase-dot"></div>' +
              '<div class="sk-chase-dot"></div>' +
              '<div class="sk-chase-dot"></div>' +
              '<div class="sk-chase-dot"></div>' +
              '<div class="sk-chase-dot"></div>' +
              '<div class="sk-chase-dot"></div>' +
            '</div>';

            _.$el.append(elem);
            $('#spinnerform').fadeIn();
        }

        if (action === 'hide') {
          $('#spinnerform').fadeOut(300, function(){
            $(this).remove();
          });
        }
      }
      /* RESIZE */
      resize() {
        var _ = this;
      }
      /* Submit the form */
      response() {
        var _ = this; 

        if (_.$el.valid()) {
          _.loader('show');
          var formdata = '';
          var dataType = 'json';
          // captcha
          if (_.$el.find('.mtcaptcha-verifiedtoken').length !== 0) {
            var currId = _.$el.find('.mtcaptcha').attr('id');
            var token = mtcaptcha.getVerifiedToken(currId);
            formdata = { token: token };
          }

          if(_.s.steps){
            dataType = null;
          }

          // SUBMIT
          _.$el.ajaxSubmit({
            data: formdata,
            dataType: dataType,
            // mimeType: "multipart/form-data",
            beforeSubmit: function (formData, jqForm, options) {
            },
            success: function (responseText, statusText, xhr, $form) {
              // console.log('SUCCESS')
              // console.log(responseText)

              _.loader('hide');
              var myStatus = responseText.Status;
              var myMessage = responseText.Message;
              var myTitle = responseText.Title;
              var myUrl = responseText.Url;

              // console.log("myStatus =" + myStatus)
              // console.log("myMessage =" + myMessage)
              // console.log("myTitle =" + myTitle)
              // console.log("myUrl =" + myUrl)

              if(_.s.steps){
                var nextStep = true;

                if($(responseText).hasClass('formSteps-end')){
                  nextStep = false;
                  $('.formSteps-nav').hide();

                  if ( $.isFunction(window.ThomFormSuccessCallback) ) {
                    ThomFormSuccessCallback();
                  }
                }

                _.replaceForm(responseText, nextStep);

              } else {

                if (myStatus == true) {

                  if ( $.isFunction(window.ThomFormSuccessCallback) ) {
                    ThomFormSuccessCallback();
                  }

                  // console.log(myUrl)
                  if (myUrl) {
                    // console.log("1")
                    window.location.href = myUrl
                  } else {
                    // console.log("2")
                    _.s.myCallback(myTitle, myMessage);
                  }

                  // Reset form fields
                  _.clearForm()
                } else {
                  if (_.s.errorMsg != null) {                    
                    _.s.errorCallback(myTitle, myMessage)
                  }
                }

                // Reset form reCaptcha
                if (_.$el.find('.thom-form__recaptcha').length != 0) {
                  grecaptcha.reset(
                    _.$el.find('.thom-form__recaptcha').attr('data-widget-id')
                  )
                }

                if (_.$el.find('.mtcaptcha-verifiedtoken').length != 0) {
                  var currId = _.$el.find('.mtcaptcha').attr('id')
                  mtcaptcha.resetUI(currId)
                }
              }

              _.$el.find('.thom-form__submit').prop('disabled', false);
            },
            error: function(res) {
              // console.log('ERROR');
            }
          })
        }
        else {
          // console.log('VALIDATION ERROR')
          if (_.s.errorMsg != null) {
            _.s.errorCallback()
            _.$el.find('.thom-form__submit').prop('disabled', false);
          }
        }
      }
      /* Reset the form */
      clearForm() {
        var _ = this

        _.$el.resetForm()

        if (_.s.errorMsg != null) {
          _.s.errorMsg.hide(0)
        }

        if (_.$el.find('input[type=file]').exists()) {
          $inputFileLabel.html(inputFileLabelVal)
        }
      }
      // Replace form
      replaceForm(res, goNextStep) {
        var _ = this;
        // console.log("replaceForm")

        var currAction = _.$el.attr('action');
        var resAction = $(res).attr('action');

        $('.thom-form-response').addClass('is-hidden');
        $('.thom-form-response').html(res);

        $('.thom-form-response').removeClass('is-hidden');
        _.loader('hide');

        if(goNextStep){
          _.$el.find('.thom-form__submit').prop('disabled', false);
          var currStep = $('.formSteps-nav .formSteps-nav-item.is-selected');
          var nextStep = currStep.next();

          if(resAction !== currAction){
            currStep
              .removeClass('is-selected')
              .addClass('is-complete');
            
            nextStep
              .attr('data-url', currAction)
              .addClass('is-selected');
          }
        }

        _.s.stepsCallback();

        
      }
    }

    // ---------------------------
    // thomForm - fn
    // ---------------------------
    $.fn.thomForm = function (options) {
      return this.each(function () {
        if (!$.data(this, 'thomForm')) {
          $.data(this, 'thomForm', new Plugin(this, options))
        } else {
          try {
            $(this)
              .data('thomForm')
              .init()
          } catch (err) {
            console.error('thomForm has not initiated properly')
          }
        }
      })
    }

    $.fn.thomForm.modules = {}
  })()
})
